<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <FITAlert ref="notice" :alertContent="$t('auth.forgetPassword.notice')" :alertSec="5" :dismissible="true"></FITAlert>
                <FITAlert ref="success" :alertContent="$t('auth.forgetPassword.success')" :alertSec="5" :dismissible="true"></FITAlert>
                <FITAlert ref="fail" :alertContent="$t('auth.forgetPassword.fail')" :alertSec="5" :dismissible="true"></FITAlert>
                <FITAlert ref="cooldown" :alertContent="$t('auth.forgetPassword.cooldown')" :alertSec="3" :dismissible="true"></FITAlert>
                <h1>{{ $t("auth.forgetPassword.forgetPassword") }}</h1>
                <p class="text-muted">{{ $t("auth.forgetPassword.forgetPasswordSubtitle") }}</p>
                <b-input-group class="my-4">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <input type="text" v-model="form.username" class="form-control" :placeholder="$t('auth.forgetPassword.username')" required>
                  <span style="padding-top:5px">{{ $t("auth.forgetPassword.example") }}</span>
                </b-input-group>
                <b-input-group class="my-4">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <!-- <input type="text" v-model="form.region" class="form-control" :placeholder="$t('auth.forgetPassword.countryCallingCode')" required> -->
                  <b-form-select v-model="form.region" :options="options"></b-form-select>
                </b-input-group>
                <b-input-group class="my-4">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-key"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <input type="text" v-model="oneTimePassword" class="form-control" :placeholder="$t('auth.forgetPassword.oneTimePassword')" required>
                </b-input-group>
                  <b-button variant="primary" @click="sendOneTimePassword" style="color: white" :disabled="disableSendOneTimePassword">{{ $t("auth.forgetPassword.sendOneTimePassword") }}</b-button>
                  <div v-if="disableSendOneTimePassword == true" style="color:red; font-size: 13px; ">{{$t("auth.forgetPassword.sendOneTimePasswordAgain") + this.timer}}</div>
                  <!-- <b-button variant="info" @click="cooldown">testing</b-button> -->
                  <!-- <span>{{this.timer}}</span> -->
                <b-input-group class="my-4">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <input type="password" v-model="form.newPassword" class="form-control" :placeholder="$t('auth.forgetPassword.newPassword')" required>
                  <span style="padding-top:5px">{{ $t("auth.forgetPassword.advise") }}</span>
                </b-input-group>
                <b-input-group class="my-4">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <input type="password" v-model="form.confirmNewPassword" class="form-control" :placeholder="$t('auth.forgetPassword.confirmNewPassword')" required>
                </b-input-group>
                <b-row>
                  <b-col cols="6" class="text-left">
                    <b-button variant="link" class="px-0" @click="backToLogin">{{ $t("auth.forgetPassword.backToLogin") }}</b-button>
                  </b-col>
                  <b-col cols="6" class="text-right">
                    <b-button variant="primary" class="px-4" @click="forgetPassword">{{ $t("auth.forgetPassword.forgetPassword") }}</b-button>
                    <!-- <b-button v-if="disable == true" variant="primary" class="px-4" @click="forgetPassword" disabled>{{ $t("auth.forgetPassword.forgetPassword") }}</b-button> -->
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import CryptoJS from 'crypto-js'
import Cookies from 'js-cookie'
import Vue from 'vue'
import {FITAlert} from '@/components'

export default {
  name: 'ForgetPassword',
  components: {
    FITAlert
  },
  data() {
    return {
      form: {
        username: '',
        region: '',
        newPassword: '',
        confirmNewPassword: ''
      },
      oneTimePassword: '',
      hash: '',
      disableForgetPassword: true,
      disableSendOneTimePassword: false,
      timer: 30,
      options: [{ value: 852, text: '852'}, {value: 86, text: '86'}]
    }
  },
  methods: {
    backToLogin() {
      this.$router.replace('/login');
    },

    forgetPassword() {
      if(this.disableForgetPassword == false){
        this.$store.dispatch('Auth/forgetPassword', this.form)
          .then((json) => {
            this.$refs.success.showAlert();
            Vue.set(this.form, 'username', '');
            Vue.set(this.form, 'region', '');
            Vue.set(this.form, 'newPassword', '');
            Vue.set(this.form, 'confirmNewPassword', '');
            this.oneTimePassword = '';
            this.hash = '';
            this.disableForgetPassword = true;
            setTimeout( ()=> this.backToLogin(), 6000);
          })
          .catch((err) => {
            console.debug(err);
          });
      }else{
        this.$refs.fail.showAlert();
      }
    },
    sendOneTimePassword() {
      if(this.disableSendOneTimePassword == false){
        this.$store.dispatch('Auth/sendOneTimePassword', this.form)
          .then((json) => {
            this.$refs.notice.showAlert();
            this.hash = json.data;
            this.disableSendOneTimePassword = true;
            this.cooldown()
          })
          .catch((err) => {
            console.debug(err);
          });
      }else{
        this.$refs.cooldown.showAlert();
      }
    },
    oneTimePasswordVerify() {
      let encrypted = CryptoJS.MD5(this.oneTimePassword);
      let hash = encrypted.toString(CryptoJS.enc.Hex);
      if(hash == this.hash && this.hash != ''){
        this.disableForgetPassword = false;
      }else{
        this.disableForgetPassword = true;
      }
    },
    cooldown(){
      let countdown = setInterval(
        function() {
          this.timer --;
          if(this.timer == 0){
            clearInterval(countdown)
            this.disableSendOneTimePassword = false
            this.timer = 30
          }
        }.bind(this)
      ,1000)
    },
  },
  created() {
    if (Cookies.get('token')) {
      this.$router.replace('/');
    }
  },
  watch: {
    oneTimePassword() {
      this.oneTimePasswordVerify();
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/Auth/components/ForgetPassword.vue